import { useEffect } from 'react'

function ExternalScriptsLoader() {
  useEffect(() => {
    // Notifica che l'app React è pronta
    const reactAppReadyEvent = new Event('react-app-ready')
    document.dispatchEvent(reactAppReadyEvent)

    // ===== ADAbe Integration =====
    // Flag per tracciare se il configuratore è già stato caricato
    window.ADABE_LOADED = false

    // Funzione per caricare ADAbe in modo asincrono
    window.loadAdabeResources = function() {
      if (window.ADABE_LOADED) return // Evita caricamenti duplicati
      window.ADABE_LOADED = true

      // Carica lo script principale
      const adabeScript = document.createElement('script')
      adabeScript.src = 'https://ciamweb.it/adabe/static_ADAbe/js/main.js'
      adabeScript.defer = true
      adabeScript.setAttribute('data-consent', 'ignore')
      document.body.appendChild(adabeScript)

      // Carica il CSS se non è già stato caricato
      if (!document.querySelector('link[href*="static_ADAbe/css/main.css"]')) {
        const adabeStyle = document.createElement('link')
        adabeStyle.rel = 'stylesheet'
        adabeStyle.href = 'https://ciamweb.it/adabe/static_ADAbe/css/main.css'
        document.head.appendChild(adabeStyle)
      }
    }

    // ===== Plyr Integration =====
    // Flag per tracciare se Plyr è già stato caricato
    window.PLYR_LOADED = false

    // Funzione per caricare Plyr in modo asincrono
    window.loadPlyrResources = function() {
      if (window.PLYR_LOADED) return // Evita caricamenti duplicati
      window.PLYR_LOADED = true

      // Carica il CSS di Plyr
      const plyrStyle = document.createElement('link')
      plyrStyle.rel = 'stylesheet'
      plyrStyle.href = 'https://cdnjs.cloudflare.com/ajax/libs/plyr/3.7.8/plyr.min.css'
      plyrStyle.crossOrigin = 'anonymous'
      plyrStyle.referrerPolicy = 'no-referrer'
      document.head.appendChild(plyrStyle)

      // Carica lo script JS di Plyr
      const plyrScript = document.createElement('script')
      plyrScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/plyr/3.7.8/plyr.min.js'
      plyrScript.crossOrigin = 'anonymous'
      plyrScript.referrerPolicy = 'no-referrer'
      document.body.appendChild(plyrScript)
    }

    // ===== Google Tag Manager Integration =====
    // Inizializza dataLayer globale
    window.dataLayer = window.dataLayer || []

    // Inizializza flag per GTM
    window.__GTM_LOADED = false // eslint-disable-line

    // Funzione che carica GTM in modo ritardato
    window.loadGTM = function() {
      if (window.__GTM_LOADED) return // eslint-disable-line
      window.__GTM_LOADED = true; // eslint-disable-line

      (function(w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        const f = d.getElementsByTagName(s)[0]
        const j = d.createElement(s); const dl = l !== 'dataLayer' ? `&l=${l}` : ''
        j.async = true
        j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
        j.setAttribute('importance', 'low') // Indica bassa priorità
        f.parentNode.insertBefore(j, f)
      }(window, document, 'script', 'dataLayer', 'GTM-KG9LD8X'))
    }

    // Carica gli script con un breve ritardo per garantire che React sia completamente renderizzato
    setTimeout(() => {
      window.loadAdabeResources()
      window.loadPlyrResources()
      window.loadGTM()
    }, 500)
  }, []) // Empty dependency array ensures this runs only once

  return null // Questo componente non renderizza nulla nel DOM
}

export default ExternalScriptsLoader
